// Angular modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';

// Third party modules
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BsDatepickerModule, BsLocaleService, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TagInputModule } from 'ngx-chips';

//routing
import { SharedListingRoutingModule } from './shared-listing-routing.module';

//Components
import { ShareGroupAddComponent } from './share-group-add/share-group-add.component';
import { TabsModule } from 'ngx-bootstrap/tabs';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        BsDatepickerModule.forRoot(),
        ReactiveFormsModule,
        BsDatepickerModule.forRoot(),
        TagInputModule,
        SharedListingRoutingModule
    ],
    declarations: [ShareGroupAddComponent],
    exports: [ShareGroupAddComponent],
})
export class SharedListingModule { }
